import { useDispatch, useSelector } from "react-redux";
import CardHeaderBG from "../../../components/components-library/card-header-bg";
import {
  setMarketAddEditVal,
  setOpenMarketAddPanel,
  udpateAddMarketData,
} from "../../../reducers/marketSlice";
import cancelIcon from "../../../assets/images/close.svg";
import { Button, Input, PanelSlider, Popover } from "../../../components/ui";
import RadioButtonBorder from "../../../components/ui/radio-button-border";
import CustomDropdown from "../../../components/components-library/dropdown";
import CustomStatusDropdown from "../../../components/components-library/custom-status-dropdown";
import AddressFields from "../../../components/components-library/address-fields";
import { useEffect, useState } from "react";
import ButtonFileUploader from "../../../components/components-library/file-upload";
import DragDropUploader from "../../../components/components-library/drag-drop-upload";
import NodataAvailable from "../../../assets/images/NodataAvailable.svg";
import useAddMarket from "./useAddMarket";
import MarketHolidays from "./add-market-holidays";
import { Add, ArrowDropDown, Download, Upload } from "@mui/icons-material";
import PartnerInfo from "../../../components/partner-info";
import Modal from "../../../components/ui/modal";
import ModalHeader from "../../../components/ui/modal/modal-header";
import MultiCropSelection from "../../../components/components-library/multi-crop-selection";
import AuctionScheduler from "./add-market-hours";
import MandiHeadSelection from "./mandi-head-selection";
import DocumentPreview from "../../../components/commons/document-preview";
import { FaXmark } from "react-icons/fa6";
import MultiSelectDropdownForSoftwares from "./multi-select-sotwares";
import { TCropOption } from "../../../types";
const AddMarket: React.FC<{ onBackClick?: any }> = ({ onBackClick }) => {
  const dispatch = useDispatch();
  const {
    handleLicenceDropdownChange,
    handleMarketStatusDropdownChange,
    martketStatusOptions,
    licenceTypeDropdownOptions,
    address,
    setAddress,
    otherSoftwareInput,
    setOtherSoftwareInput,
    softwares,
    handleAddSoftware,
    handleRemoveSoftware,
    handleImportHolidaylist,
    handleChangeHoliday,
    handleDeleteHoliday,
    handleHolidaysAdd,
    holidays,
    marketDetailsEditStatus,
    employeeCountDropdownOptions,
    mandiEmployeesData,
    onUpdateAddMarketInput,
    addMarketDetails,
    handleEmpCountDropdownChange,
    onSaveMarketData,
    showCropModal,
    setShowCropModal,
    selectedCrops,
    addCropItem,
    softwareOptions,
    selectedSoftwares,
    setSelectedSoftwares,
    setMandiHeadDropdown,
    mandiHeadDropdown,
    bankOptions,
    selectedBanks,
    setSelectedBanks,
    onUploadImage,
    onRemoveImage,
    marketImages,
    schedules,
    backupSchedules,
    activeDay,
    setActiveDay,
    handleAddAuction,
    handleDeleteAuction,
    handleSelectOption,
    revertAllDays,
    applyToAllDays,
    handleToggleDay,
    onUpdateMarketData,
    removeCropItem,
    showRevert,
  } = useAddMarket();
  const [searchTerm, setSearchTerm] = useState("");
  const mappedSelectedCrops: TCropOption[] = selectedCrops.map((item) => ({
    cropId: item.cropId,
    cropName: item.cropName,
    imageUrl: item.imageUrl,
    type: item.type ?? "",
    varietyName: item.varietyName,
    baseName: item.baseName,
    status: item.status,
    cropUrl: item.imageUrl,
    id: item.cropId,
  }));
  return (
    <>
      <div className="border-b card_space_18 flex items-center justify-between">
        <div className="flex flex-col">
          <span className="text-sm ">
            {marketDetailsEditStatus ? "Edit" : "Add"} Market
          </span>
        </div>

        <img
          src={cancelIcon}
          alt="Close"
          className="cursor-pointer"
          onClick={() => {
            dispatch(setOpenMarketAddPanel(false));
            if (marketDetailsEditStatus) {
              dispatch(setMarketAddEditVal("details"));
            }
          }}
        />
      </div>
      <div
        className="outlet_padding flex gap-4 overflow-y-auto"
        style={{ height: "calc(100vh - 10rem)" }}
      >
        {" "}
        <div className="w-50">
          <CardHeaderBG
            titile={"Market Details"}
            titileClassName="bg-oceangreen"
            icon=""
            className=""
          >
            <div className="card_space_18">
              <div className="flex">
                <Input
                  label="Market Name "
                  type="text"
                  required={true}
                  value={addMarketDetails?.marketName}
                  className="flex-1"
                  onChange={(e) => {
                    onUpdateAddMarketInput("MARKETNAME", e.target.value);
                  }}
                />
              </div>
              <div className="flex gap-4 space_18">
                <div style={{ borderRadius: "10px" }} className="flex-1">
                  <label className="fs-14">
                    Longitude
                    <span className="color-red">{"*"}</span>
                  </label>
                  <input
                    type={"number"}
                    className={`mt-[8px] w-full px-3.5 py-2 br-10 fs-14 bg-white border focus:border-green-500 `}
                    onWheel={(e) => (e.target as HTMLElement).blur()}
                    onChange={(e) => {
                      onUpdateAddMarketInput("LONGITUDE", e.target.value);
                    }}
                    value={
                      addMarketDetails?.address?.longitude > 0
                        ? addMarketDetails?.address?.longitude
                        : ""
                    }
                  />
                </div>
                <div style={{ borderRadius: "10px" }} className="flex-1">
                  <label className="fs-14">
                    Latitude
                    <span className="color-red">{"*"}</span>
                  </label>
                  <input
                    type={"number"}
                    className={`mt-[8px] w-full px-3.5 py-2 br-10 fs-14 bg-white border focus:border-green-500 `}
                    onWheel={(e) => (e.target as HTMLElement).blur()}
                    onChange={(e) => {
                      onUpdateAddMarketInput("LATITUDE", e.target.value);
                    }}
                    value={
                      addMarketDetails?.address?.latitude > 0
                        ? addMarketDetails?.address?.latitude
                        : ""
                    }
                  />
                </div>
              </div>
              <div className="space_18 flex gap-4 items-end">
                <div className="flex-1">
                  <label className="fs-14">
                    Market Type
                    {/* <span className="color-red">{"*"}</span> */}
                  </label>
                  <RadioButtonBorder
                    displayType="horizontal"
                    data={[
                      { label: "SOURCE", value: "SOURCE" },
                      { label: "DESTINATION", value: "DESTINATION" },
                      { label: "DUAL", value: "DUAL" },
                    ]}
                    value={addMarketDetails?.marketType}
                    pointer={{ label: "label", value: "value" }}
                    onChange={(value) => {
                      onUpdateAddMarketInput("MANDITYPE", value);
                    }}
                    styles={{
                      display: "flex",
                      gap: "0.5rem",
                      width: "100%",
                    }}
                    className="h-[39px]"
                  />
                </div>
                <div className="flex-1">
                  <CustomDropdown
                    label="Market License Type "
                    options={licenceTypeDropdownOptions}
                    value={addMarketDetails?.licenceType}
                    onChange={handleLicenceDropdownChange}
                    placeholder=""
                    className=""
                    // required={true}
                  />
                </div>
              </div>
              <div className="space_18 flex gap-4 items-end">
                <div className="flex-1">
                  {/* <CustomStatusDropdown
                    label="Market Status "
                    options={martketStatusOptions}
                    value={addMarketDetails?.status}
                    onChange={handleMarketStatusDropdownChange}
                    placeholder=""
                    fromTrader={true}
                    isMandatory={true}
                  /> */}
                  <Input
                    label="Number of Mandi/Shops"
                    value={addMarketDetails?.shopCount || ""}
                    onChange={(e) => {
                      onUpdateAddMarketInput("NO.OFSHOPS", e.target.value);
                    }}
                  />
                </div>
                <div className="flex-1">
                  <label className="fs-14">
                    Market Size
                    {/* <span className="color-red">{"*"}</span> */}
                  </label>
                  <RadioButtonBorder
                    displayType="horizontal"
                    data={[
                      { label: "LARGE", value: "LARGE" },
                      { label: "MID", value: "MID" },
                      { label: "SMALL", value: "SMALL" },
                    ]}
                    value={addMarketDetails?.marketSize}
                    pointer={{ label: "label", value: "value" }}
                    onChange={(value) => {
                      onUpdateAddMarketInput("MANDISIZE", value);
                    }}
                    styles={{
                      display: "flex",
                      gap: "1rem",
                      width: "100%",
                    }}
                    className="h-[39px]"
                  />
                </div>
              </div>

              <div className="space_18 flex gap-4 items-end">
                <CustomDropdown
                  label="Market Status"
                  options={martketStatusOptions}
                  value={addMarketDetails?.status}
                  onChange={handleMarketStatusDropdownChange}
                  placeholder=""
                  className="flex-1"
                  required={true}
                />
                <div className="flex-1"></div>
              </div>
            </div>
            <div>
              <div
                className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t`}
              >
                <span className="fs-14">
                  Market Address
                  <span className="color-red">{"*"}</span>
                </span>
              </div>
              <div className="card_space_18">
                <AddressFields
                  label=""
                  value={address}
                  onChange={(val) => setAddress(val)}
                />
              </div>
            </div>
            <div>
              <div
                className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t`}
              >
                <span className="fs-14">mOS Users</span>
              </div>
              <div className="card_space_18">
                <div className="flex gap-4">
                  <Input
                    label="CLICK (Estimate)"
                    type="number"
                    value={addMarketDetails?.users.clickCount}
                    className="flex-1"
                    disabled={true}
                    // onChange={(e) => {
                    //   onUpdateAddMarketInput("CACOUNT", e.target.value);
                    // }}
                  />
                  <Input
                    label="TRADE (Estimate)"
                    type="number"
                    value={addMarketDetails?.users.tradeCount}
                    className="flex-1"
                    disabled={true}
                    // onChange={(e) => {}}
                  />
                  <Input
                    label="CASH (Estimate)"
                    type="number"
                    value={addMarketDetails?.users.cashCount}
                    className="flex-1"
                    disabled={true}
                    // onChange={(e) => {}}
                  />
                </div>
              </div>
            </div>
            <div>
              <div
                className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t`}
              >
                <span className="fs-14">APMC Office</span>
              </div>
              <div className="card_space_18">
                <div className="flex gap-4 items-end">
                  <div className="flex-1">
                    <label className="fs-14">
                      APMC Office
                      {/* <span className="color-red">{"*"}</span> */}
                    </label>
                    <RadioButtonBorder
                      displayType="horizontal"
                      data={[
                        { label: "YES", value: "YES" },
                        { label: "NO", value: "NO" },
                      ]}
                      value={addMarketDetails?.apmcStatus}
                      pointer={{ label: "label", value: "value" }}
                      onChange={(value) => {
                        onUpdateAddMarketInput("OFFICENAME", value);
                      }}
                      styles={{
                        display: "flex",
                        gap: "1rem",
                        width: "100%",
                      }}
                      className="h-[39px]"
                    />
                  </div>
                  <CustomDropdown
                    label="How many Employees"
                    options={employeeCountDropdownOptions}
                    value={addMarketDetails?.empCount}
                    onChange={handleEmpCountDropdownChange}
                    placeholder=""
                    className="flex-1"
                    required={false}
                  />
                  <Input
                    label="Office Head"
                    type="text"
                    value={addMarketDetails?.headName}
                    className="flex-1"
                    onChange={(e) => {
                      onUpdateAddMarketInput("OFCHEAD", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div>
                <div
                  className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t justify-between`}
                >
                  <span className="fs-14">Top Crops</span>
                  <Button
                    variant="outlined-primary"
                    data-shape="round"
                    onClick={() => {
                      setShowCropModal(true);
                    }}
                    className=" h-[30px]"
                  >
                    <Add style={{ fontSize: 16, color: "color-primary" }} />
                    Add Crop
                  </Button>
                </div>
                <div className="card_space_18">
                  {selectedCrops?.filter((crop) => crop.status !== 0).length >
                  0 ? (
                    <div>
                      <div className="grid grid-cols-3  gap-4 relative">
                        {selectedCrops
                          ?.filter((crop) => crop.status !== 0)
                          .map((i) => (
                            <div className="flex  gap-2 items-center flex-1 border br-10 justify-between p-2">
                              <div className="flex gap-2 items-center">
                                <div>
                                  <img
                                    src={i.cropUrl || i.imageUrl}
                                    alt="ui"
                                    className="br-100"
                                    style={{ width: "25px", height: "25px" }}
                                  />
                                </div>
                                <div className="fs-14">{i.cropName} </div>
                              </div>
                              <span
                                className="cursor-pointer color-red"
                                onClick={() => {
                                  removeCropItem(i.cropId);
                                }}
                              >
                                {" "}
                                ✕
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center justify-center w-full h-full">
                      <img src={NodataAvailable} alt="No data available" />
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div
                  className={`card_bg_head bg-oceangreen border-t flex gap-2 items-center `}
                >
                  <span className="fs-14">Market Pictures</span>
                </div>
                <div className="card_space_18">
                  <div className="">
                    <div className="flex justify-between items-center">
                      <label className="fs-14">
                        Market Pictures
                        {/* <span className="color-red">{"*"}</span> */}
                      </label>
                      <ButtonFileUploader
                        onChange={(e: any) => {
                          if (e.target.files) {
                            onUploadImage("MARKETS", e.target.files);
                          }
                        }}
                        id="uploader_mandi"
                      />
                    </div>
                    <div className="flex gap-4 mt_8">
                      {marketImages.filter((doc) => doc.status != 0).length ===
                        0 && (
                        <DragDropUploader
                          onDrop={(acceptedFiles: any) => {
                            if (acceptedFiles.length > 0) {
                              onUploadImage("MARKETS", acceptedFiles);
                            }
                          }}
                        />
                      )}
                      <div
                        className="flex gap-2 overflow-x-auto"
                        style={{ width: "100%" }}
                      >
                        {marketImages
                          .filter((doc) => doc.status != 0)
                          .map((image, i) => (
                            <div
                              className="shrink-0 overflow-hidden border doc_card rounded relative"
                              key={`OTHER-${i}`}
                            >
                              <a href={image.url} target="_blank">
                                <DocumentPreview
                                  url={image.url}
                                  docType={
                                    image.url?.toLowerCase().endsWith(".pdf")
                                      ? "pdf"
                                      : image.url
                                          ?.toLowerCase()
                                          .match(/\.(mp4|webm|mov)$/)
                                      ? "video"
                                      : "image"
                                  }
                                />
                              </a>
                              <span
                                className="absolute right-0 top-0 p-1 rounded-full cursor-pointer"
                                style={{
                                  background: "#ff0000",
                                }}
                                onClick={() => {
                                  onRemoveImage(
                                    image.url,
                                    image.status === 2,
                                    image.id
                                  );
                                }}
                              >
                                <FaXmark style={{ color: "white" }} />
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div
                  className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t`}
                >
                  <span className="fs-14">3rd Party Market Softwares</span>
                </div>
                <div className="card_space_18">
                  <MultiSelectDropdownForSoftwares
                    options={softwareOptions}
                    selected={selectedSoftwares}
                    onChange={setSelectedSoftwares}
                    placeholder="Search by Software Name and Select"
                    fromMainScreen={true}
                  />
                  {/* <AddMandiSoftwares
                    inputValue={otherSoftwareInput}
                    softwares={softwares}
                    setInputValue={setOtherSoftwareInput}
                    handleAdd={handleAddSoftware}
                    handleRemove={handleRemoveSoftware}
                  /> */}
                </div>
              </div>
              <div>
                <div
                  className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t`}
                >
                  <span className="fs-14">Banking Partners</span>
                </div>
                <div className="card_space_18">
                  <MultiSelectDropdownForSoftwares
                    options={bankOptions}
                    selected={selectedBanks}
                    onChange={setSelectedBanks}
                    placeholder="Search by Bank Name and Select"
                    fromMainScreen={true}
                  />
                  {/* <AddMandiBanks
                    inputValue={otherSoftwareInput}
                    softwares={softwares}
                    setInputValue={setOtherSoftwareInput}
                    handleAdd={handleAddSoftware}
                    handleRemove={handleRemoveSoftware}
                  /> */}
                </div>
              </div>
            </div>
          </CardHeaderBG>
        </div>
        <div className="w-50">
          <CardHeaderBG
            titile={"Market Hours"}
            titileClassName="bg-oceangreen"
            icon=""
            className=""
          >
            <div className="card_space_18">
              <AuctionScheduler
                schedules={schedules}
                backupSchedules={backupSchedules}
                activeDay={activeDay}
                setActiveDay={setActiveDay}
                handleAddAuction={handleAddAuction}
                handleDeleteAuction={handleDeleteAuction}
                handleSelectOption={handleSelectOption}
                revertAllDays={revertAllDays}
                applyToAllDays={applyToAllDays}
                handleToggleDay={handleToggleDay}
                showRevert={showRevert}
              />
            </div>
            <div>
              <div
                className={`card_bg_head bg-oceangreen flex gap-2 items-center border-t justify-between`}
              >
                <span className="fs-14">Market Holidays</span>

                <div className="flex items-center gap-2">
                  <label className="flex items-center gap-1 border border-primary color-primary px-3 py-1 rounded-full cursor-pointer justify-center transition h-[35px]">
                    <Download style={{ fontSize: 18 }} />
                    <span className="text-sm font-semibold">
                      Import from Excel
                    </span>
                    <input
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={handleImportHolidaylist}
                      className="hidden"
                    />
                  </label>
                  <Button
                    variant="outlined-primary"
                    data-shape="round"
                    onClick={handleHolidaysAdd}
                    className="h-[35px]"
                  >
                    <Add style={{ fontSize: 16 }} />
                    Add Holiday
                  </Button>
                </div>
              </div>
              <div className="card_space_18">
                <MarketHolidays
                  handleChangeHoliday={handleChangeHoliday}
                  handleDeleteHoliday={handleDeleteHoliday}
                  holidays={holidays}
                />
              </div>
            </div>
          </CardHeaderBG>
          <CardHeaderBG
            titile={"ONO Risk Details"}
            titileClassName="bg-oceangreen"
            icon=""
            className="space_18"
          >
            <div className="card_space_18 ">
              {" "}
              <div className="flex-1">
                <label className="fs-14">
                  Market Head
                  {/* <span className="color-red">{"*"}</span> */}
                </label>
                <div
                  className="py-2 px-3.5 border cursor-pointer br-10 mt_8"
                  onClick={() => {
                    setMandiHeadDropdown(true);
                    // setSearchTerm("");
                  }}
                >
                  <div className="relative flex items-center h-full">
                    <span className="text-center ml-2 text-sm font-semibold">
                      {addMarketDetails?.employee?.onoId ? (
                        <PartnerInfo
                          profilePic={addMarketDetails?.employee?.profilePic}
                          name={addMarketDetails?.employee?.name}
                          shortName={""}
                          partnerType={"ONO ID"}
                          partnerId={addMarketDetails?.employee?.onoId}
                          partnerMobile={addMarketDetails?.employee?.mobile}
                          partyName={""}
                        />
                      ) : (
                        "Select Market Head"
                      )}
                    </span>

                    <span
                      className="absolute right-0 color-primary"
                      // style={{ top: "-3px" }}
                    >
                      <ArrowDropDown />
                    </span>
                  </div>
                </div>

                {/* relationship manager dropdown */}
                <div className="ml-[30%] w-full">
                  <Popover
                    open={mandiHeadDropdown}
                    onClose={() => {
                      setMandiHeadDropdown(false);
                    }}
                    className="w-[20%] bg-red h-auto"
                  >
                    <div>
                      <MandiHeadSelection
                        rmId={addMarketDetails?.employee?.onoId || 0}
                        onChange={(rm) => {
                          onUpdateAddMarketInput("ONOID", rm);

                          setMandiHeadDropdown(false);
                        }}
                        onClear={() => {
                          setSearchTerm("");
                        }}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                      />
                    </div>
                  </Popover>
                </div>
              </div>
              <div className="flex space_18 gap-4">
                <Input
                  label="RM Risk Score "
                  type="number"
                  // required={true}
                  value={addMarketDetails?.rmOrs || ""}
                  onChange={(e) => {
                    onUpdateAddMarketInput("RMORS", e.target.value);
                  }}
                  className="flex-1"
                />
                <Input
                  label="Market Risk Score "
                  type="number"
                  // required={true}
                  value={addMarketDetails?.marketOrs || ""}
                  onChange={(e) => {
                    onUpdateAddMarketInput("MARKETORC", e.target.value);
                  }}
                  className="flex-1"
                />
              </div>
            </div>
          </CardHeaderBG>
        </div>
      </div>
      <>
        <div className="bg-white flex absolute  bottom-0 justify-between items-center gap-10 px-6 py-4 w-full border-t">
          <Button
            className="w-26"
            variant="oceanGreen"
            data-shape="round"
            onClick={() => {
              if (!marketDetailsEditStatus) {
                dispatch(setOpenMarketAddPanel(false));
              } else {
                onBackClick();
              }
            }}
          >
            Cancel
          </Button>
          <Button
            // className="w-[100px]"
            variant="contained"
            onClick={() => {
              if (marketDetailsEditStatus) {
                onUpdateMarketData();
              } else {
                onSaveMarketData();
              }
            }}
          >
            Save
          </Button>
        </div>
      </>
      {showCropModal === true && (
        <>
          <Modal
            open={showCropModal}
            onClose={() => {
              setShowCropModal(false);
            }}
            width="32vw"
            // height="60vh"
          >
            <>
              <ModalHeader title={"Select Crop"} content={<></>} />
              <div className="py-3 px-6">
                <MultiCropSelection
                  selectionMode={"multiple"}
                  onSelect={(crops) => {
                    addCropItem(crops);
                    setShowCropModal(false);
                  }}
                  selectedCropsData={mappedSelectedCrops}
                />
              </div>
            </>
          </Modal>
        </>
      )}
    </>
  );
};
export default AddMarket;
